import React from 'react';

interface SpinV2Props {
  loading: boolean;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const SpinV2: React.FC<SpinV2Props> = ({
  loading,
  children,
  className = '',
  style = {},
}) => {
  if (!loading) {
    return <>{children}</>;
  }

  return (
    <div className={`relative ${className}`} style={style}>
      {children}
      <div className="absolute inset-0 flex items-center justify-center bg-black/20 z-50">
        <svg width="32" height="32" className="animate-spin">
          <circle
            cx="16"
            cy="16"
            r="13"
            stroke="var(--1)"
            strokeWidth="4"
            fill="none"
            strokeDasharray="40 20"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default SpinV2;
